import { HTTP_TOKEN } from "./http";

export const Account = () => {
  return HTTP_TOKEN.get("account").then(result => {
    return result.data;
  });
};

export const updateAccount = data => {
  return HTTP_TOKEN.put("account", data).then(result => {
    return result.data;
  });
};

